import React, { useEffect, useState } from 'react';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { QuoteHeaderDetail } from '../Quote/QuoteHeaderDetail';
import { QuoteListing } from '../Quote/QuoteListing';
import { OpenQuoteListing } from '../Quote/OpenQuoteListing';
import QuoteDetail from '../Quote/QuoteDetail';
import QuoteAddress from '../Quote/QuoteAddress';
import Helper from 'src/helper/Helper';

export function Quote() {
    const [selectedTab, setSelectedTab] = useState('')
    const QuoteType = System.getParams().__c
    const { QuotePages } = Constants

    useEffect(() => {
        setSelectedTab(QuoteType ? QuoteType : QuotePages.OpenQuoteListing.param_value);
    }, [QuoteType])

    useEffect(() => {
        Helper.feedBackButtonScript()
       }, []);
    return (
        <div className="logged-screen">
            {selectedTab === QuotePages.QuoteHeaderDetail.param_value && <QuoteHeaderDetail />}
            {selectedTab === QuotePages.QuoteListing.param_value && <QuoteListing />}
            {selectedTab === QuotePages.OpenQuoteListing.param_value && <OpenQuoteListing />}
            {selectedTab === QuotePages.QuoteDetail.param_value && <QuoteDetail />}
            {selectedTab === QuotePages.QuoteAddress.param_value && <QuoteAddress />}
        </div>
    );
}